import React from 'react'
import renderChildUIComponents from './metadata-mapper'
import Col from '../base-components/Col'
import { FlatDomainDataContext, FormBean, IUIContainerDef, IUIRepeatableContainerDef } from '../../datatypes';
import classNames from 'classnames';

interface ContainerProps {
    metadata:IUIContainerDef|IUIRepeatableContainerDef;
    formBean:FormBean;
    ctx:FlatDomainDataContext;

    /** additional class names */
    className?: string;
    /** use the children passed from props directly instead of render its own children ui defs */
    useChildren?:boolean;
}

export default class Container extends React.Component<ContainerProps,{}> {
  render() {
    const {metadata} = this.props;
    const {title, properties, cssClasses} = metadata;
    let className = classNames('baseContainer', cssClasses, this.props.className);

    let {xs, sm, md, lg} = properties;

    return (
      <Col xs={xs} sm={sm} md={md} lg={lg}>
        <div className={className}>
          {title && <h3 className="mdHeading">{title}</h3>}
          {this.props.useChildren? this.props.children : renderChildUIComponents(this.props)}
        </div>
      </Col>
    )
  }
}